export default __webpack_public_path__ + "static/media/contextual-chocolate.200f91fb.png";